import React, {Component, Fragment} from 'react';
import {Typography, Container, Button, Icon} from '@material-ui/core';
import FormInput from './../components/FormInput'
//import Image from './Image'

const Form = () => {
    /* const methods = useForm();
    const { control, handleSubmit, errors } = methods;
    const onSubmit = data => console.log(data); */
    //const LabelHTML = (props) => <Fragment></Fragment>
    return (
        <Fragment>
            <form style={{display: "inline-block"}} /* onSubmit={handleSubmit(onSubmit)} */>
                <div style={{width:'320px', display: "inline-block", verticalAlign: "top"}}>
                    <FormInput as='TextField'
                        placeholder="Ingresá tu mail"
                        id="subscribe"
                        name="subscribe"
                        label="subscribe"
                        defaultValue=""
                        classnamecustom=""
                    />
                </div>
                <Button className="button" variant="contained" color="secondary" type="submit">Enviar</Button>
            </form>
        </Fragment>
    )
}

class Subscribe extends Component {
    /* constructor(props) {
        super(props)
        //console.log(props)
    } */

    render() {
        return (
            <section className="subscribe">
                <Container> 
                    <Typography className="title" variant="h6" style={{display: "inline-block"}} >
                        <Icon className="icon_title">mail_outlined</Icon> Registrate y recibí nuestras ofertas
                    </Typography>
                    <Form />
                </Container>           
            </section>
        )
    }
}

export default Subscribe


